
import React from 'react';

interface MotivationalBackdropProps {
  onDismiss: () => void;
}

export const MotivationalBackdrop = ({ onDismiss }: MotivationalBackdropProps) => {
  return (
    <div 
      className="fixed inset-0 z-[9998] bg-black/80 backdrop-blur-sm"
      onClick={onDismiss}
    />
  );
};
